module.exports = __webpack_public_path__ + "static/media/01.f6b00615.png";